import { useEffect } from "react";

interface UseClevertapProps {
  isClevertapOn: boolean;
  isClient: boolean;
  page_name: string;
  environment: string;
  userData: any;
  extra_params: any;
}

const useClevertap = ({
  isClevertapOn,
  isClient,
  page_name,
  environment,
  userData,
  extra_params,
}: UseClevertapProps) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    if (
      !isClevertapOn ||
      !isClient ||
      !page_name ||
      !environment ||
      !userData?.recruiter_id
    ) {
      return;
    }

    // Dynamically import the clevertap library on client
    import("@foundit/clevertap")
      .then((mod) => {
        const {cleverTapTracking} = mod.default || mod;

        const urlParams = new URLSearchParams(window.location.search);
        const origin = urlParams.get("origin");
        const updatedExtraParams = { ...extra_params, ...(origin && { origin }) };

        cleverTapTracking({
          userData,
          pageName: page_name,
          environment,
          extra_params: updatedExtraParams,
        });
      })
      .catch((err) => {
        console.error("Failed to load CleverTap tracking:", err);
      });
  }, [
    isClient,
    userData?.recruiter_id,
    page_name,
    environment,
    isClevertapOn,
  ]);

  return {};
};

export default useClevertap;
